<template>
	<div>

		<breadcrumbs />


		<div class="content-i">
			<div class="content-box">
				<div class="row pt-4">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">
                                Terminal Devices
							</h6>
							<div class="element-box-tp">
								<div class="table-responsive">
									<table class="table table-padded">
										<thead>
										<tr>
											<th><input class="form-control" placeholder="Search Terminal ID" type="number" v-model="id"/></th>
											<th><input class="form-control" placeholder="Reseller ID" type="number" v-model="resellerID"/></th>
										</tr>
										<tr>
											<th>ID</th>
											<th>Name</th>
											<th>Created At</th>
											<th>Status</th>
										</tr>
										</thead>
										<tbody>
										<tr v-for="d in device">
											<td>
											{{ d.id }}
											</td>
											<td>
											{{ d.username }}
											</td>
											<td>
											{{ dateTimeFormat(d.createdAt) }}
											</td>
											<td class="nowrap">
											<span class="status-pill smaller green"></span>
											<span>Active</span>
											</td>
											<td class="row-actions">
												<a href="javascript:;" v-on:click="resetDevice(d.id)" v-tooltip="'Restart Device Sign'">
													<i class="os-icon os-icon-grid-18"></i>
												</a>
											</td>
										</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'list',
        data () {
            return {
                t: this.$root.t,
				isLoading: false,
				resellerID: null,
				id: null,
				device: null
            }
        },
		watch: {
			'resellerID' (){
				this.fetchDevices()
			},
			'id' (){
				this.fetchDevices()
			}
		},
		mounted() {
			this.fetchDevices()
		},
		methods: {
			resetDevice(id){
				this.$http.post(api+"api/v2/terminal/reset?id="+id, {id: id}) .then(response => {
					swal('', this.t.processing.success, "success")
				}, response => {
                    swal(this.t.processing.error, this.t.processing.check, "error")
                })
			},
			fetchDevices(){
				this.$http.get(api+"api/v2/terminal/devices?reseller="+this.resellerID+"&id="+this.id).then(response => {
					if(Array.isArray(response.body.result)){
						this.device = response.body.result
					}else {
						this.device = [response.body.result]
					}
				}, response => {
                    this.error = response.body.msg
                })
			}
		}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/terminal/list.vue